import { render, staticRenderFns } from "./DealTagManageModal.vue?vue&type=template&id=2a25584a&"
import script from "./DealTagManageModal.vue?vue&type=script&lang=js&"
export * from "./DealTagManageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports